import { render } from "./ResultList.vue?vue&type=template&id=8c349202&scoped=true"
import script from "./ResultList.vue?vue&type=script&lang=ts"
export * from "./ResultList.vue?vue&type=script&lang=ts"

import "./ResultList.vue?vue&type=style&index=0&id=8c349202&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-8c349202"

export default script